import CMS from 'netlify-cms-app'
import uploadcare from 'netlify-cms-media-library-uploadcare'
import cloudinary from 'netlify-cms-media-library-cloudinary'
import './cms-utils'

import BeliefsPagePreview from './preview-templates/BeliefsPagePreview'
import EventsPagePreview from './preview-templates/EventsPagePreview'
import IndexPagePreview from './preview-templates/IndexPagePreview'
import LivestreamPagePreview from './preview-templates/LivestreamPagePreview'
import SermonsPagePreview from './preview-templates/SermonsPagePreview'
import YouthPagePreview from './preview-templates/YouthPagePreview'
import GivingPagePreview from './preview-templates/GivingPagePreview'
import ContactPagePreview from './preview-templates/ContactPagePreview'

CMS.registerMediaLibrary(uploadcare)
CMS.registerMediaLibrary(cloudinary)

CMS.registerPreviewTemplate('index', IndexPagePreview)
CMS.registerPreviewTemplate('beliefs', BeliefsPagePreview)
CMS.registerPreviewTemplate('events', EventsPagePreview)
CMS.registerPreviewTemplate('livestream', LivestreamPagePreview)
CMS.registerPreviewTemplate('sermons', SermonsPagePreview)
CMS.registerPreviewTemplate('youth', YouthPagePreview)
CMS.registerPreviewTemplate('giving', GivingPagePreview)
CMS.registerPreviewTemplate('contact', ContactPagePreview)
